import { ComponentProps, ReactNode, useState } from "react";

import { twMerge } from "tailwind-merge";

type Props = {
  fallback?: ReactNode;
  fallbackUrl?: string;
} & ComponentProps<"img">;

export const Img = ({
  className,
  fallbackUrl = "",
  fallback,
  ...props
}: Props) => {
  const [isError, setIsError] = useState<boolean>(false);

  if (isError && fallback) {
    return fallback;
  }

  return (
    <img
      {...props}
      alt={props.alt}
      className={twMerge("select-none", className)}
      onError={(e) => {
        if (!fallbackUrl) {
          setIsError(true);
          return;
        }
        e.currentTarget.onerror = null;
        e.currentTarget.src = fallbackUrl;
      }}
      src={props.src ?? fallbackUrl}
    />
  );
};
